import { Stack, Typography, useTheme } from "@mui/material";
import { PlusIcon } from "../svgIcon/PlusIcon";

const AVCTableAddItem = ({ onAdd, title, isCreateAddingTitleHide }) => {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack
        sx={{
          cursor: "pointer",
        }}
        direction="row"
        alignItems="center"
        justifyContent="start"
        onClick={onAdd}
        gap={1}
      >
        <PlusIcon color={theme.palette.primary.main} fontSize="small" />
        <Typography variant="body1" color="primary.main">
          {!isCreateAddingTitleHide && " افزودن "}
          {title}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default AVCTableAddItem;
